import request from "@/utils/request";
import config from '@/config/index'
import enumObject from "@/utils/enum";
const GateWay = enumObject.providerConfig[config.projectName].gateway;
// 城建手机号解密
export function decrypt (data) {
  return request({
    url: GateWay + "/temporary/decrypt",
    method: "post",
    data
  });
}
// 登录
export function login (data) {
  return request({
    url: GateWay + "/handleWx/getUserInfo",
    method: "post",
    data
  });
}
// 注册
export function register (data) {
  return request({
    url: GateWay + "/handleWx/registered",
    method: "post",
    data
  });
}
// 绑定用户和平台标识
export function updateUserInfo (data) {
  return request({
    url: GateWay + "/handleWx/updateUserInfo",
    method: "post",
    data
  });
}
// 无牌车入场
export function unlicensedAdmission (data) {
  return request({
    url: GateWay + "/mainPlatform/Admission",
    method: "post",
    data
  });
}
// 手机号码获取验证码
export function sendMeaasge (data) {
  return request({
    url: GateWay + "/handleWx/SendMsgV1",
    method: "post",
    data
  });
}
// 手机号码登录
export function loginByPhone (data) {
  return request({
    url: GateWay + "/handleWx/verificationCodeV2",
    method: "post",
    data
  });
}
// 替换新手机号码登录
export function newLoginByPhone (data) {
  return request({
    url: GateWay + "/user/api/updatePhone",
    method: "post",
    data
  });
}